import Router from 'next/router'

const handleRouteChange = () => {
  window.scrollTo(0, 0)
  Router.events.off('routeChangeComplete', handleRouteChange)
}

export default ({
  href,
  as,
  replace = false,
  scroll = true,
  options = null,
}) => {
  if (scroll) {
    Router.events.on('routeChangeComplete', handleRouteChange)
  }

  const goToRoute = replace ? Router.replace : Router.push
  const asRoute = as || href

  if (options) {
    return goToRoute(href, asRoute, options)
  }

  return goToRoute(href, asRoute)
}
